(function () {
  var DESKTOP_MIN = 990;

  function fitRibbonLabels() {
    document.querySelectorAll('.naori-subscribe-save__ribbon').forEach(function (ribbon) {
      var text = ribbon.querySelector('.naori-subscribe-save__ribbon-text');
      if (!text) return;

      if (window.innerWidth < DESKTOP_MIN) {
        text.style.fontSize = '';
        text.style.letterSpacing = '';
        text.style.fontWeight = '';
        return;
      }

      text.style.fontSize = '15px';
      text.style.letterSpacing = '0.22em';
      text.style.fontWeight = '400';
      text.style.lineHeight = '1.45';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fitRibbonLabels);
  } else {
    fitRibbonLabels();
  }

  window.addEventListener('resize', fitRibbonLabels);
  document.addEventListener('shopify:section:load', fitRibbonLabels);
})();
